<div fxLayout="column" fxLayoutGap="24px">
  <h3>Resync Lock</h3>
  <span>
    If you changed the lock codes directly on the lock or notice missing or mismatched codes, you can resync the lock to
    make sure that the codes from Hospitable match the ones on the lock.
  </span>

  <div fxLayoutAlign="start center" fxLayoutGap="12px">
    <a
      href="https://my.hospitable.com/support-documentation/article/5757397-how-to-connect-my-smart-lock#h_2fe04d83cd"
      target="_blank"
      class="link">
      Learn more about Resync
    </a>
    <div fxFlex></div>
    <sbnb-button type="secondary" (click)="dialogRef.close(false)">Cancel</sbnb-button>
    <sbnb-button type="primary" (click)="dialogRef.close(true)">Resync lock</sbnb-button>
  </div>
</div>
